import React, { useMemo, useState } from 'react';
import { useLazyDashboardMessagesQuery } from '../../../../graphql/graphql';
import Loading from '../../../BaseModule/Components/Loading';
import DashboardMessagesItem, {
	DashboardMessagesItemScheme,
} from './DashboardMessagesItem';
// @ts-ignore
import styles from './DashboardMessages.module.scss';
import LinkButton from '../../../BaseModule/Components/Button/LinkButton/LinkButton';
import { useEffectAsync } from '../../../../helpers';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';

interface Props {
	patientId: string;
}

const DashboardMessages: React.FC<Props> = ({ patientId }) => {
	const [getMessages] = useLazyDashboardMessagesQuery();
	const [isShowMoreOpen, setIsShowMoreOpen] = useState(false);
	const [isMoreAvailable, setIsMoreAvailable] = useState(false);
	const [data, setData] = useState<DashboardMessagesItemScheme[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	const handleLoadData = async () => {
		setIsLoading(true);
		const tempItems: DashboardMessagesItemScheme[] = [];
		const { data } = await getMessages();
		data?.dashboardMessages?.forEach(item => {
			if (item) {
				tempItems.push({
					id: item.id,
					image: item?.sender?.user?.profileImageUrl ?? undefined,
					subtitle: item?.content?.title ?? undefined,
					title: item?.sender?.user?.profile?.fullName ?? undefined,
					wizardKey: item?.content?.wizardId,
					entityId: item?.content?.workplaceMemberId,
					conversationId: item?.content?.conversationId,
					notificationId: item.id,
					icon: item?.content?.icon ?? undefined,
				});
			}
		});
		if (tempItems.length > 3) {
			setIsMoreAvailable(true);
		}
		setData(tempItems);
		setIsLoading(false);
	};

	const items = useMemo(() => {
		return isShowMoreOpen ? data : data.slice(0, 3);
	}, [data, isShowMoreOpen]);

	useEffectAsync(async () => {
		await handleLoadData();
	}, []);

	useSocket(Socket.REFRESH_DASHBOARD_MESSAGES, handleLoadData);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.list}>
				{items.map(item => (
					<DashboardMessagesItem item={item} />
				))}
			</div>
			{isMoreAvailable && (
				<LinkButton
					text={isShowMoreOpen ? 'base.showLess' : 'base.showNext'}
					theme='purple'
					onClick={() => setIsShowMoreOpen(!isShowMoreOpen)}
					className={styles.button}
					firstUpper
				/>
			)}
		</div>
	);
};

export default DashboardMessages;
